import React from 'react';
export function Hook() {
  return <section className="w-full bg-ink text-cream" data-id="element-88" data-mp="3vc9d4p5tbcx">
      <div className="mx-auto max-w-3xl px-5 py-16 lg:py-24" data-id="element-89" data-mp="2b6v1qurec1qr">
        <h2 className="font-display text-3xl font-black leading-tight sm:text-4xl" data-id="element-90" data-mp="2b48wj1rz9ybp">
          ¿Llegás a las 7 de la tarde y lo primero que escuchás es{' '}
          <span className="text-butter" data-id="element-91" data-mp="2197704tsiu8l">“¿Qué hay de comer?”</span>?
        </h2>
        <div className="mt-7 space-y-5 font-sans text-lg leading-relaxed text-cream/80" data-id="element-92" data-mp="2ox8agzc43kh5">
          <p data-id="element-93" data-mp="2twjs0akaytzs">
            Esa pregunta es el inicio de la peor parte del día. Abrís la heladera, no hay
            nada listo. Terminás improvisando un plato aburrido, ensuciando toda la cocina
            o, peor aún, gastando $20.000 en un delivery que llega frío.
          </p>
          <p data-id="element-94" data-mp="2k4nje5klblhb">
            La “carga mental” de planificar viandas y cenas todos los días te está robando
            tiempo que podrías pasar descansando o con tus hijos.
          </p>
        </div>
        <p className="mt-8 font-display text-2xl font-bold text-butter sm:text-3xl" data-id="element-95" data-mp="3cp5ngtrasiju">
          Cocinar no debería ser un castigo.
        </p>
      </div>
    </section>;
}